import { LanguageModel } from '..';

export class Constants {
  // Registration/Activiation
  public static readonly INITIAL_ACTIVATION_KEY = 'initialActivation';
  // General
  public static readonly ONE_ADDED_TO_SHOW_COMMENTS_QUESTION_PROGRESS: number = 1;
  public static readonly NUMBER_OF_QUESTIONS_PER_INDICATOR_GROUP: number = 15;
  public static readonly NUMBER_OF_INDICATOR_QUESTIONS: number = 75;
  public static readonly NUMBER_OF_EFFECTIVENESS_QUESTIONS: number = 8;
  public static readonly ACTION_NO_ACTION: string = 'NO_ACTION';
  public static readonly MAXIMUM_NUMBER_OF_DISPLAY_NOTIFICATIONS: number = 6;

  // UI
  public static readonly FIRST_NAME_MAXIMUM_LENGTH = 100;
  public static readonly LAST_NAME_MAXIMUM_LENGTH = 100;
  public static readonly PASSWORD_MAXIMUM_LENGTH = 100;
  public static readonly PASSWORD_MINIMUM_LENGTH = 6;
  public static readonly EMAIL_ADDRESS_MAXIMUM_LENGTH = 256;
  public static readonly ISBN_NUMBER_MAXIMUM_LENGTH = 100;
  public static readonly SURVEY_NAME_MAXIMUM_LENGTH = 300;
  public static readonly SURVEY_HEADER_HEIGHT = 70;
  public static readonly SURVEY_SUBHEADER_HEIGHT = 132;
  public static readonly BOOK_URL = 'https://www.amazon.com/Above-Line-Living-Leading-Heart-ebook/dp/B07QQKHXK8/';
  public static readonly HEARTSTYLES_BUSINESS_ACCOUNT_LINK = 'https://live.heartstylesapp.com';
  public static readonly PRIVACY_POLICY_LINK = 'https://heartstyles.com/privacy';
  public static readonly TERMS_OF_AGREEMENT_LINK = 'https://heartstyles.com/terms';
  public static readonly THE_HEARTSTYLES_INDICATOR_LINK = 'https://heartstyles.com/the-heartstyles-indicator';
  public static readonly COOKIE_POLICY_KEY = 'hs-cookie-policy';
  public static readonly COOKIE_POLICY_EXPIRY = 365;

  public static readonly DEFAULT_LANGUAGE: LanguageModel = {
    id: 1,
    name: 'English',
    nativeName: 'English',
    isoTwoLetterName: 'en',
    isoThreeLetterName: 'ENG',
    cultureCode: 'GB',
    isRtl: false
  };
}
